// @ts-nocheck
export const localeCodes =  [
  "en"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  }
]
/** client **/

/** client-end **/